'use client';

import { SessionProvider } from 'next-auth/react';
import { ReactNode } from 'react';
interface ClientSessionProviderProps {
  readonly children: ReactNode;
}
export default function ClientSessionProvider({
  children
}: ClientSessionProviderProps) {
  return <SessionProvider data-sentry-element="SessionProvider" data-sentry-component="ClientSessionProvider" data-sentry-source-file="ClientSessionProvider.tsx">{children}</SessionProvider>;
}